import axiosInstance from "../utils/api-util/utilApi"

const config = { baseURL: process.env.REACT_APP_TRANSACTION_SERVICE_URL || '' }

export const getTransactionDetailById = (id: string): Promise<any> => {
  const url = 'Transactions/getDetail/' + id
  return axiosInstance.get(url, config)
}

export const voidACheck = (id: string): Promise<any> => {
  const url = `Transactions/voidACheck?id=${id}`
  return axiosInstance.put(url, {}, config)
}

export const viewCheckImage = (id: string): Promise<any> => {
  const url = `Transactions/viewImage/${id}`
  return axiosInstance.get(url, config)
}